import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.icon)
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass(_ctx.iconClass)
      }, null, 2))
    : _createCommentVNode("", true)
}